export default __webpack_public_path__ + "static/31-ac9b7608c54759164cc2ed47a31c03f8.jpg";